export default "__VITE_ASSET__B7oR01xz__"